import styled from 'styled-components'
import { Inset } from '@doordash/design-language'

export const ImageContainer = styled.div`
  height: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ContentContainer = styled(Inset)`
  display: flex;
  flex-direction: column;
  height: 70%;
  justify-content: space-around;
`

export const Container = styled.div`
  height: 100vh;
`
